jQuery(document).ready(function($) {
    WilliamsAv = new function()
    {
        this.init = function() {
            WilliamsAv.dataTables();
            WilliamsAv.deleteItemAlert();
            WilliamsAv.quickAddDevice();
            WilliamsAv.changeCurrencies();
            WilliamsAv.requireStateOnlyIfUS();
            WilliamsAv.requireVenueNameOnlyIfOther();

            jQuery('body').on('click', '.ajax-modal', function(event) {
                event.preventDefault();
                var href  = jQuery(this).attr('href');
                var modal = jQuery(this).data('bs-target');
                WilliamsAv.loadAjaxModal(href, modal);
            });

            jQuery('body').on('click', '.copy-text-to-clipboard', function(event) {
                var $temp = jQuery("<input>");
                jQuery("body").append($temp);
                $temp.val(jQuery(this).data('copy-text')).select();
                document.execCommand("copy");
                $temp.remove();
                jQuery(this).append('<span class="clipboard-copy-success">Copied!</span>');

                setTimeout(function() {
                    jQuery('.clipboard-copy-success').remove();
                }, 1500);
            });
        };

        /**
         * Build data tables with individual column filters
         */
        this.dataTables = function() {
            $('.data-table-no-search').each(function(index, el) {
                var default_sort = 0;
                jQuery(el).find('th').each(function(index2, el2) {
                    if(jQuery(el2).hasClass('default-sort')) {
                        default_sort = index;
                    }
                });

                $(el).DataTable({
                  "searching": false,
                  "order": [[ default_sort, "asc" ]],
                  "columnDefs": [
                    { type: 'natural', targets: '_all' }
                  ],
                  "fnDrawCallback": function(oSettings) {
                      if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
                      } else {
                           $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                           $(oSettings.nTableWrapper).find('.dataTables_info').show();
                      }
                  }
                });
            });

            jQuery('.data-table').each(function(index, el) {
                var default_sort = 0;
                jQuery(el).find('th').each(function(index2, el2) {
                    if(jQuery(el2).hasClass('default-sort')) {
                        default_sort = index;
                    }
                });

                $(el).find('thead th').each(function() {
                    var title = $(this).text();
                    if(title == 'Currency') {
                        var currency_select = jQuery('select[name="currency_type"]');
                        jQuery(this).append( currency_select );
                    } else if(title == 'Role') {
                        var role = jQuery('select[name="role"]');
                        jQuery(this).append( role );
                    } else if(title == 'Tier') {
                        var tier = jQuery('select[name="tier"]');
                        jQuery(this).append( tier );
                    } else if(title == 'Tax Exempt') {
                        var tax_exempt = jQuery('select[name="tax_exempt"]');
                        jQuery(this).append( tax_exempt );
                    } else if(title != 'Action') {
                        jQuery(this).append( '<input type="text" placeholder="Search '+title+'" />' );
                    }
                });
             
                var table = $(el).DataTable({
                    dom: 'Qlfrtip',
                    "order": [[ default_sort, "asc" ]],
                    "columnDefs": [
                      { type: 'natural', targets: '_all' }
                    ],
                    "fnDrawCallback": function(oSettings) {
                        if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
                            $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
                            $(oSettings.nTableWrapper).find('.dataTables_info').hide();
                        } else {
                             $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
                             $(oSettings.nTableWrapper).find('.dataTables_info').show();
                        }
                    },
                    initComplete: function() {
                        this.api().columns().every(function() {
                            var that = this;
             
                            //Contains string
                            jQuery( 'input', this.header() ).on( 'keyup change clear', function() {
                                if ( that.search() !== this.value ) {
                                    that
                                        .search( this.value )
                                        .draw();
                                }
                            });

                            //Exact Match
                            jQuery( 'select', this.header() ).on( 'keyup change clear', function() {
                                if(!this.value) {
                                    that
                                        .search( '' )
                                        .draw();
                                }
                                else if ( that.search() !== this.value ) {
                                    that
                                        .search("^" + $(this).val() + "$", true, false, true)
                                        .draw();
                                }
                            });
                        });
                    }
                });
            });

            jQuery('.data-table input, .data-table select').click(function(event) {
                event.stopPropagation();
            });
        };

        /**
         * Load dynamic content into a bootstrap modal
         *
         * @param string href - ajax route to load
         * @param string modal - id of modal to open
         */
        this.loadAjaxModal = function(href, modal) {
            $.ajax({
                url: href,
                type: 'GET',
                showloader: true,
                success: function(response) { 
                    $(modal).find('.modal-body').html(response);
                    $(modal).modal('show'); 
                }
            });
        };

        /**
         * Triggers a confirm window when customer tries to delete an item
         */
        this.deleteItemAlert = function() {
            jQuery('body').on('click', '.delete-item-alert', function(event) {
                var r = confirm("Are you sure you want to delete this item?");
                if (r == true) {
                  return true;
                } else {
                    return false;
                }
            });
        };

        /**
         * Handles the device quick add form on the admin dashboard
         */
        this.quickAddDevice = function() {
            jQuery('.device-quick-add-form input[name="serial_number"]').keyup(function(event) {
                this.value = this.value.replace(/[^0-9\.]/g,'');
            });

            jQuery('.device-quick-add-form').submit(function(event) {
                event.preventDefault();
                var href           = jQuery(this).attr('action');
                var serial_number  = jQuery('input[name="serial_number"]').val();
                var device_type_id = jQuery('select[name="device_type_id"]').val();
                var token          = jQuery('meta[name="csrf-token"]').attr('content');

                if(serial_number.length != 13) {
                    alert('Please enter a valid serial number');
                    return false;
                }

                $.ajax({
                    url: href,
                    type: 'POST',
                    data: { 
                        serial_number: serial_number, 
                        device_type_id: device_type_id, 
                        _token: token 
                    },
                    showloader: true,
                    success: function(response) { 
                        jQuery('body').addClass('print-code');
                        jQuery('.device-quick-add-form .form-response').html(response.msg);
                    }
                });
            });
        };

        /**
         * Handles changing of currency type on the tiers grid
         */
        this.changeCurrencies = function() {
            jQuery('.tiers-currencies-change-currency-type').change(function(event) {
                var currency         = jQuery(this).val();
                window.location.href = window.location.pathname+"?"+jQuery.param({'currency':currency});
            });
        };

        /**
         * Require state dropdown only if US is selected in country dropdown
         * Also, show/hide the tax exempt box
         */
        this.requireStateOnlyIfUS = function() {
            jQuery('#country').change(function(event) {
                if(jQuery(this).val() == "US") {
                    jQuery('#state').attr('required', 'required');
                    jQuery('#state').prop('required', 'required');
                    jQuery('.col-form-label[for="state"]').html('State <span class="required-label">*</span></label>');
                    jQuery('.tax-exempt-row').show();
                } else {
                    jQuery('#state').removeAttr('required');
                    jQuery('#state').removeProp('required');
                    jQuery('#state').val('');
                    jQuery('.col-form-label[for="state"]').html('State');
                    jQuery('.tax-exempt-row').hide();
                    if(!jQuery('input[name="tax_exempt"]').is(':disabled')) {
                        jQuery('input[name="tax_exempt"]').prop('checked', false);
                    }
                }
            });

            jQuery('#country').trigger('change');
        };

        /**
         * Show venue name if user selects venue type of "other" and make required
         * Do the reverse if not selecting "other" on venue type
         */
        this.requireVenueNameOnlyIfOther = function() {
            jQuery('select#venue_type').change(function(event) {
                if(jQuery(this).val() == '1') {
                    jQuery('.venue-other-row').show();
                    jQuery('.venue-other-row input').attr('required', 'required');
                    jQuery('.venue-other-row input').prop('required', 'required');
                } else {
                    jQuery('.venue-other-row').hide();
                    jQuery('.venue-other-row input').removeAttr('required');
                    jQuery('.venue-other-row input').removeProp('required');
                }
            });
        };
    }

    WilliamsAv.init();
});
